// extracted by mini-css-extract-plugin
module.exports = {"root":"az_o-b"};